import {FC, MouseEventHandler, ReactElement} from 'react';
import './FontAwesomeButton.less';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import type {IconProp} from "@fortawesome/fontawesome-svg-core";
import {useLocation} from "wouter";
import {motion} from "framer-motion";

export type FontAwesomeButtonProps = {
    backgroundColor?: string;
    className?: string;
    icon: IconProp;
    iconColor?: string;
    iconOnly?: boolean;
    label?: string | ReactElement;
    labelColor?: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
    primaryColor?: string;
    secondaryColor?: string;
    route?: string;
}

const FontAwesomeButton: FC<FontAwesomeButtonProps> = props => {
    const {className = '', icon, iconColor = '', iconOnly, label = '', labelColor = '', backgroundColor = '', route = '', onClick} = props;
    const trimmed = iconOnly ? 'trimmed' : '';

    const [, navigate] = useLocation();

    const handleMouseDown: MouseEventHandler<HTMLDivElement> = e => {
        e.preventDefault();
        e.stopPropagation();

        if (onClick) onClick(e);
        if (route) setTimeout(() => navigate(route), 250);
    }

    return (
        <motion.div className={`font-awesome-button ${trimmed} ${className}`.trimEnd()}
                    style={{
                        backgroundColor: backgroundColor || undefined,
                        color: labelColor || undefined,
                    }}
                    role='button'
                    onMouseDown={handleMouseDown}
                    whileHover={{scale: 1.1}}
                    whileTap={{scale: 0.9}}
        >
            <FontAwesomeIcon icon={icon} color={iconColor} size='lg' />
            {label && <label>{label}</label>}
        </motion.div>
    );
}

export default FontAwesomeButton;